import * as AccordionPrimitive from "@radix-ui/react-accordion";

export type Faq = { q: string; a: string };
export type FaqVars = { duration: number | string; smartPrice?: number | string | null };

/** Always true, whatever the catalog says (Redesign v3 board copy). */
export function homeBaseFaqs({ duration }: FaqVars): Faq[] {
  return [
    {
      q: "كيف بتصير الاستشارة؟",
      a: `جلسة فردية ${duration} دقيقة مع د. سارة، أونلاين من أي مكان أو بالعيادة بأبو رمانة، دمشق. بتراسلونا على واتساب أول شي لنتفق على اليوم والساعة، وبعدها بتعبّوا طلب الحجز مع استمارة قصيرة عن طفلكم بتوصل لد. سارة قبل الجلسة.`,
    },
    {
      q: "بتناسب الاستشارة المراهقين؟",
      a: "تركيزنا الأساسي على الطفولة المبكرة والمتوسطة، لأنو هون بتنبني أسس الجهاز العصبي — بس مفاهيم العلاقة بتنطبق على كل الأعمار.",
    },
    {
      q: "كيف بيكون الدفع؟",
      a: "من خارج سوريا عبر PayPal، ومن داخلها عبر شام كاش أو حوالة الهرم، والحجز بيتأكّد بعد مراجعة الإيصال. جلسات العيادة فيها كمان دفع كاش يوم الموعد. كل المبيعات نهائية.",
    },
    {
      q: "شو هي البوصلة؟",
      a: "أداة من د. سارة لاكتشاف الذات والتخصص الأقرب: 8 محاور منها الذكاءات والميول المهنية والشخصية والقيم، للشباب من 15 لـ 35 سنة. مجانية، والتقرير بيطلع فور الانتهاء.",
    },
  ];
}

/** Added only while the Smart product is active in the catalog. */
export function smartFaq({ smartPrice }: FaqVars): Faq {
  return {
    q: "شو الفرق بين البوصلة والبوصلة الذكية؟",
    a: `البوصلة مجانية وبتعطي التقرير الشخصي فوراً. الذكية (${smartPrice ?? ""}$) بتبني على النتيجة والتفضيلات تقرير مفصّل: التخصصات الأنسب، مقارنة بين الخيارات، التحديات، وخطة 30 يوم — بيوصل خلال 24 ساعة من تعبئة نموذج التفضيلات وبيراجعه فريق د. سارة.`,
  };
}

export function homeFaqs(smartActive: boolean, vars: FaqVars): Faq[] {
  const base = homeBaseFaqs(vars);
  return smartActive ? [...base, smartFaq(vars)] : base;
}

/** v3 FAQ accordion: hairline rows, +/− indicator, answers always in the server HTML. */
export function Faqs({ items }: { items: Faq[] }) {
  return (
    <AccordionPrimitive.Root type="single" collapsible defaultValue="faq-0" className="flex flex-col gap-2">
      {items.map((item, i) => (
        <AccordionPrimitive.Item
          key={i}
          value={`faq-${i}`}
          className="group rounded-[20px] border border-hairline-subtle bg-cream-50 transition-colors duration-ds-fast data-[state=open]:bg-surface"
        >
          <AccordionPrimitive.Header className="flex">
            <AccordionPrimitive.Trigger className="flex min-h-14 flex-1 cursor-pointer items-center justify-between gap-4 rounded-[20px] px-5 py-3 text-start font-display text-[16px] font-bold text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-maroon-500">
              {item.q}
              <span
                aria-hidden
                className="grid h-[30px] w-[30px] shrink-0 place-items-center rounded-full bg-maroon-100 font-display text-lg font-extrabold leading-none text-maroon-500"
              >
                <span className="group-data-[state=open]:hidden">+</span>
                <span className="hidden group-data-[state=open]:inline">−</span>
              </span>
            </AccordionPrimitive.Trigger>
          </AccordionPrimitive.Header>
          <AccordionPrimitive.Content forceMount className="data-[state=closed]:hidden">
            <p className="max-w-[66ch] px-5 pb-5 text-[15px] leading-[1.8] text-text-secondary">{item.a}</p>
          </AccordionPrimitive.Content>
        </AccordionPrimitive.Item>
      ))}
    </AccordionPrimitive.Root>
  );
}
